import Chip from '@mui/material/Chip';
import { t } from 'i18next';
import type { JSX } from 'react';

interface CreateOptionChipProps {
  name: string;
  onClick: () => void;
  disabled?: boolean;
  'data-test-id'?: string;
  'data-ui'?: string;
}

export function CreateOptionChip({
  name,
  onClick,
  disabled,
  ...dataAttributes
}: CreateOptionChipProps): JSX.Element {
  return (
    <Chip
      {...dataAttributes}
      color="brandV2Green"
      disabled={disabled}
      // i18n.ts escapes globally, so a name containing "/" would render as `&#x2F;`; React still escapes on render.
      label={t('common.add_new_name', { name, interpolation: { escapeValue: false } })}
      onClick={onClick}
      size="small"
      variant="filled"
      sx={{ cursor: 'pointer' }}
    />
  );
}
